import React, { useState, useEffect, useCallback } from "react";
import SupportLayout from "../support/SupportLayout";
import ProgressContent from "../support-officer/components/ProgressContent";
import {
  _get_support_executive_progress_dashboard,
  _get_new_support_orders,
} from "../../common/axios_services";

const AdminProgress = () => {
  const [progressData, setProgressData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10, total: 0 });

  const getDefaultDates = useCallback(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const dateStr = `${year}-${month}-${day}`;
    return { dateFrom: dateStr, dateTo: dateStr };
  }, []);

  const fetchProgressDashboard = useCallback(
    async (dateFrom, dateTo, supportManagerId, supportOfficerId) => {
      try {
        setLoading(true);
        const res = await _get_support_executive_progress_dashboard(
          dateFrom,
          dateTo,
          supportManagerId,
          supportOfficerId,
        );
        setProgressData(res?.data?.data || null);
      } catch (err) {
        console.error("Error fetching progress dashboard:", err);
        setProgressData(null);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const fetchOrders = useCallback(
    async (tab = "sales", page = 1, limit = 10, supportManagerId, supportOfficerId) => {
      try {
        setLoading(true);
        const { dateFrom } = getDefaultDates();
        const res = await _get_new_support_orders(tab, page, limit, supportManagerId, supportOfficerId, dateFrom);
        setOrders(res?.data?.data?.orders || []);
        setPagination(res?.data?.data?.pagination || { page: 1, limit: 10, total: 0 });
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  useEffect(() => {
    const defaultDates = getDefaultDates();
    fetchProgressDashboard(defaultDates.dateFrom, defaultDates.dateTo, null, null);
    fetchOrders("all", 1, 100);
  }, [fetchProgressDashboard, fetchOrders, getDefaultDates]);

  return (
    <SupportLayout userRole="ADMIN">
      <ProgressContent
        useOwnLayout={true}
        showFilter={true}
        filterType="team"
        externalData={progressData}
        externalLoading={loading}
        externalFetchData={fetchProgressDashboard}
        externalGetDefaultDates={getDefaultDates}
        externalFetchOrders={fetchOrders}
        externalOrders={orders}
        externalPagination={pagination}
        userRole="ADMIN"
      />
    </SupportLayout>
  );
};

export default AdminProgress;
